<section>
  <div class="row justify-content-center">
    <div class="col-xm-12 col-sm-10 col-md-8 col-lg-3 col-xl-3 customChart">
      <app-statistics-chart></app-statistics-chart>
    </div>
    <div class="col-xm-12 col-sm-10 col-md-10 col-lg-8 col-xl-6 customCamera">
      <app-camera-view></app-camera-view>
    </div>
    <div class="col-xm-10 col-sm-10 col-md-4 col-lg-4 col-xl-2 customChart">
      <app-menu></app-menu>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-xm-12 col-sm-12 col-md-1 col-lg-1 col-xl-2 ml-1"></div>
    <div class="col-xm-12 col-sm-12 col-md-9 col-lg-7 col-xl-7 customChart2">
      <app-chart #chartComponent></app-chart>
    </div>
    <div class="col-xm-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 ml-1"></div>
  </div>
</section>
